import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ReadonlyField from '../ReadonlyField';
import TextField from '../TextField';

PrivilegedTextField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    readonly: PropTypes.bool,
};

PrivilegedTextField.defaultProps = {
    sufficientReadPrivileges: null,
    readonly: false,
};

function PrivilegedTextField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        readonly,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const canWrite = !readonly && hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <TextField {...rest} />
            )
            : (
                canRead && (
                    <ReadonlyField
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedTextField;
